/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from '@/lib/api';

/** Pannello Amministrazione → Email: configurazione SMTP/SendGrid della clinica (credenziali cifrate lato server). */
export const getEmailConfig = () => api.get('/admin/email-config').then((r) => r.data);
export const saveEmailConfig = (payload) => api.put('/admin/email-config', payload).then((r) => r.data);
export const deleteEmailConfig = () => api.delete('/admin/email-config').then((r) => r.data);
/** Invia la vera notifica "Nuovo referto disponibile" di prova (default: al mittente). */
export const sendTestEmail = (to) => api.post('/admin/email-config/test', { to: to || null }).then((r) => r.data);
